import React, { createContext, useContext, useState, useCallback } from "react";

const OpsRoleContext = createContext(null);

export function OpsRoleProvider({ children }) {
  const [role, setRoleState] = useState(() => localStorage.getItem("ops_role") || "manager");
  const setRole = useCallback((r) => {
    localStorage.setItem("ops_role", r);
    setRoleState(r);
  }, []);
  return (
    <OpsRoleContext.Provider value={{ role, setRole }}>{children}</OpsRoleContext.Provider>
  );
}

export const useOpsRole = () => useContext(OpsRoleContext);
